<template>
  <CartNotification>
    <template #header>
      <span class="font-weight-bold font16">{{ text }}</span>
    </template>
    <template #content>
      {{ $t('notifications.item-added.cart-merged') }}
    </template>
    <template #action>
      <CartNotificationButton
        @terminate-notification="emits('terminate-notification')"
      />
    </template>
  </CartNotification>
</template>

<script setup lang="ts">
import CartNotification from '~/components/notification/cart/base/CartNotification.vue'
import CartNotificationButton from '~/components/notification/cart/common/CartNotificationButton.vue'

const props = withDefaults(defineProps<{
  productQty?: number
}>(), {
  productQty: 0
})
const emits = defineEmits<{
  (e: 'terminate-notification'): void
}>()

const $i18n = useI18n()

const text = computed(() => props.productQty > 1
  ? $i18n.t('notifications.item.added.header.text.multiple', { productQty: props.productQty })
  : $i18n.t('notifications.item.added.header.text')
)
</script>

<style lang="scss">

</style>
